import { OperationStatus } from 'src/types';
import { useDependencyManagerContext } from 'src/contexts/dependencyManager';

export type SharedTableState = {
  isLoading: boolean;
  isErrored: boolean;
  noDeviceName: string;
  unknownDeviceName: string;
};

export function useSharedTableState(status: OperationStatus): SharedTableState {
  const { translate } = useDependencyManagerContext();

  return {
    isLoading: status === OperationStatus.RUNNING,
    isErrored: status === OperationStatus.ERRORED,
    noDeviceName: translate('components.device-item.no-data.name'),
    unknownDeviceName: translate('components.device-item.no-data.unknown')
  };
}
